module.exports = __webpack_public_path__ + "img/info-two-3.9164cd07.png";